export default () => {
  if (document.querySelectorAll('.hype-innovation-form').length) {
    return import(/* webpackChunkName: "form-validation" */ '../components/forms/form-animation')
      .then(({ default: FormAnimation }) => new FormAnimation())
      .catch((error) => `Form validation : ${error}`);
  }
  return null;
};
